import { render } from "./EditLabel.vue?vue&type=template&id=5a2995a4&scoped=true"
import script from "./EditLabel.vue?vue&type=script&lang=js"
export * from "./EditLabel.vue?vue&type=script&lang=js"

import "./EditLabel.vue?vue&type=style&index=0&id=5a2995a4&lang=css&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2995a4"]])

export default __exports__